
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Modal from "components/miscellaneous/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import {setWhatsNewState} from "store/app-slice"
import WhatsNewDialog from "./WhatsNewDialog";

const WhatsNew = ({show, userId, userRole}) => {
    const dispatch = useDispatch();
    const [showDialog, setShowDialog] = useState(false);
    const isShown = useSelector(state => state.app.show_whats_new)

    useEffect(() => {
        if(isShown != showDialog) {
            dispatch(setWhatsNewState(showDialog));
        }
    }, [showDialog])

    useEffect(() => {
        if(isShown != showDialog) {
           setShowDialog(isShown);
        }
    }, [isShown])

    const onClose = (res) => {
        setShowDialog(false)
    }

    return (
        <Modal content={<WhatsNewDialog userRole={userRole} isVisible={isShown} onClose={onClose} />}
            onClose={onClose}
            modalStyle={{
                borderRadius: '10px',
                padding: 0,
                overflowY: 'unset',
                background: 'transparent',
            }}
            modalContainerStyle={{
                background: 'transparent',
                boxShadow: 'none'
            }}
            showCloseButton={false}
            visible={isShown} 
        />
    )
}

export default WhatsNew;